import classNames from 'classnames';
import { Button } from 'components/buttons';
import { IActionsProps, IActionVariant } from './ButtonPanel';

export interface IButtonPanelGroupProps {
  actions: IActionsProps[];
  variant?: IActionVariant;
  position: 'left' | 'right';
}

export function ButtonPanelGroup({ position, actions, variant = 'decisions' }: IButtonPanelGroupProps) {
  return (
    <div className={classNames('dp-button-panel__group', `dp-button-panel__group--${position}`)}>
      {(actions || []).map(action => (
        <Button
          id={action.id}
          key={action.name}
          variant={'decisions' ? 'secondary' : 'material'}
          fontWeight={variant === 'decisions' ? 'medium' : undefined}
          onClick={action.onClick}
          disabled={action.isDisabled}
          style={action.styles}
          className="dp-button-panel__button"
          tabIndex={action.tabIndex}
        >
          {action.name}
        </Button>
      ))}
    </div>
  );
}
